
import React, { useState } from 'react';

import { useTranslation, Trans } from "react-i18next";
 
import Button from '../Button'

import b from '../../img/ProductsArvest/button.png'

const CJV = () => {

    const { t } = useTranslation();

    const [active, setActive] = useState(0);

    const setTab = value => active === value
        ? setActive(-1)
        : setActive(value);

    const data = [
        {
            title: 'productsarvest.17',
            description: 'productsarvest.18',
        },
        {
            title: 'productsarvest.19',
            description: 'productsarvest.20',
        },
        {
            title: 'productsarvest.21',
            description: 'productsarvest.22',
        },
        {
            title: 'productsarvest.23',
            description: 'productsarvest.24',
        },
    ]
               
    return (
        <section className="relative open-sans pt-[90px] xl:pt-[160px]">
            <div className="relative z-10 max-w-[1220px] mx-[20px] xl:mx-auto">
                <div className="flex xl:flex-row flex-col justify-between gap-[30px]">
                   <div>
                       <p className="spantext text-[#0C2780] font-[700] text-[23px] xl:text-[45px] open-sans"><Trans>{t('productsarvest.16')}</Trans></p>
                       <Button color={'#15318D'} text={'#FFFFFF'} className={'hidden xl:block mt-[40px]'}/>
                   </div>
                   <div>
                    <div className="flex flex-col gap-[8px] md:w-[644px]">
                        {data.map((tab, index) =>
                            <div
                                key={index}
                                onClick={() => setTab(index)}
                                className="flex flex-col py-[12px] lg:py-[15px] sm:px-[20px] px-[10px] cursor-pointer border-b border-[#00000033]"
                            >
                                <div className="flex gap-[15px] items-center justify-between">
                                    <h4 className="xl:w-[439px] lg:w-[280px] font-[600] open-sans sm:text-[19px] text-[14px] text-[#0C2780] select-none">
                                        <Trans>{t(tab.title)}</Trans>
                                    </h4>
                                    <div className="relative flex-shrink-0">
                                        <img src={b} alt="" className={index === active ? 'rotate-45 transition-all' : 'transition-all'}/>
                                    </div>
                                </div>
                                <div className={`${index === active ? 'flex' : 'hidden'} w-auto font-[300] open-sans sm:text-[16px] text-[14px] text-[#0C2780] mt-[15px]`}>
                                    <p className="">
                                        <Trans>{t(tab.description)}</Trans>
                                    </p>
                                </div>
                            </div>
                        )}
                    </div>
                   </div>
                </div>
            </div>
        </section>
    )
};

export default CJV;
